function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAA IDP Form - Summary: Licence details component
 * 
 */

import * as React from 'react';
import Text from '../text/Text';
import { connect } from 'react-redux';
import { Fn } from '../../../functions/Functions';
import '../Summary.scss';
import { DELIVERY_METHOD_POSTAGE } from '../../../data/Data';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export class LicenceDetails extends React.Component {
  render() {
    const {
      addresses,
      deliveryMethod,
      images,
      licenceClass,
      licenceExpiry,
      licenceNumber,
      names,
      stateOfIssue
    } = this.props;
    return /*#__PURE__*/_jsx("div", {
      id: "licence-details",
      children: /*#__PURE__*/_jsxs("div", {
        className: "details",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "text-list",
          children: [/*#__PURE__*/_jsx(Text, {
            label: "Licence number",
            name: "licenceNumber",
            value: licenceNumber.value
          }), /*#__PURE__*/_jsx(Text, {
            label: "Licence class",
            name: "licenceClass",
            value: licenceClass.value
          }), /*#__PURE__*/_jsx(Text, {
            label: "Licence expiry date",
            name: "licenceExpiry",
            value: Fn.invertDate(licenceExpiry.value)
          }), /*#__PURE__*/_jsx(Text, {
            label: "State of issue",
            name: "licenceStateOfIssue",
            value: stateOfIssue.value
          }), /*#__PURE__*/_jsx(Text, {
            label: "Address on licence",
            name: "licenceAddress",
            value: addresses.licenceAddress?.value
          }), deliveryMethod?.value === DELIVERY_METHOD_POSTAGE.value && /*#__PURE__*/_jsxs("div", {
            children: [names.licenceDeliveryAddressFullName?.value ? /*#__PURE__*/_jsx(Text, {
              label: "Delivery name",
              name: "licenceDeliveryAddressFullName",
              value: names.licenceDeliveryAddressFullName?.value
            }) : null, /*#__PURE__*/_jsx(Text, {
              label: "Delivery address",
              name: "licenceDeliveryAddress",
              value: addresses.licenceDeliveryAddress?.value
            })]
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "photo full-width",
          children: [/*#__PURE__*/_jsx("img", {
            src: images.licenceFront.value,
            alt: "Licence front"
          }), /*#__PURE__*/_jsx("p", {
            children: "Licence front"
          }), /*#__PURE__*/_jsx("img", {
            src: images.licenceBack.value,
            alt: "Licence back"
          }), /*#__PURE__*/_jsx("p", {
            children: "Licence back"
          })]
        })]
      })
    });
  }
}
_defineProperty(LicenceDetails, "defaultProps", {
  addresses: {
    licenceAddress: {
      value: ''
    },
    licenceDeliveryAddress: {
      value: ''
    }
  },
  club: {
    autoClub: {
      error: false,
      value: ''
    }
  },
  deliveryMethod: {
    error: false,
    value: ''
  },
  images: {
    licenceBack: {
      value: ''
    },
    licenceFront: {
      value: ''
    }
  },
  licenceClass: {
    error: false,
    value: ''
  },
  licenceDetailsRef: {
    current: {
      offsetTop: {}
    }
  },
  licenceExpiry: {
    error: false,
    value: ''
  },
  licenceNumber: {
    error: false,
    value: ''
  },
  names: {
    licenceAddressFullName: {
      error: false,
      value: ''
    }
  },
  stateOfIssue: {
    error: false,
    value: ''
  }
});
const mapStateToProps = ({
  addresses,
  club,
  deliveryMethod,
  images,
  licenceClass,
  licenceExpiry,
  licenceNumber,
  names,
  stateOfIssue
}) => {
  return {
    addresses,
    club,
    deliveryMethod,
    images,
    licenceClass,
    licenceExpiry,
    licenceNumber,
    names,
    stateOfIssue
  };
};
const VisibleLicenceDetails = connect(mapStateToProps)(LicenceDetails);
export default VisibleLicenceDetails;